<template>
  <div>
    <p v-if="!isAppRedirected">Redirecting to app...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAppRedirected: false
    }
  },
  mounted() {
    // Try to open the app directly
    const deepLink = 'yummable://recipe';
    const fallbackUrl = 'https://apps.apple.com/us/app/yummable/id6743863350';

    if (isMobile()) {
      // Redirect to app via deep link
      window.location.href = deepLink;

      // After a short delay, fallback to the App Store
      setTimeout(() => {
        if (!this.isAppRedirected) {
          window.location.href = fallbackUrl;
        }
      }, 2000);
    }
  }
};

function isMobile() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}
</script>

<style>
</style>
